import Image from 'next/image';
import { CiSettings } from 'react-icons/ci';

import chatActiveIcon from '@/assets/sidenav-icons/Chat-Active.svg';
import chatIdleIcon from '@/assets/sidenav-icons/Chat-Idle.svg';
import contactsActiveIcon from '@/assets/sidenav-icons/Contacts-Active.svg';
import contactsIdleIcon from '@/assets/sidenav-icons/Contacts-Idle.svg';
import tasksActiveIcon from '@/assets/sidenav-icons/icon-tasks-page-active.svg';
import tasksIdleIcon from '@/assets/sidenav-icons/icon-tasks-page-idle.svg';
import jobsActiveIcon from '@/assets/sidenav-icons/Jobs-Active.svg';
import jobsIdleIcon from '@/assets/sidenav-icons/Jobs-Idle.svg';
import meActiveIcon from '@/assets/sidenav-icons/Me-Active.svg';
import meIdleIcon from '@/assets/sidenav-icons/Me-Idle.svg';
import nnuActiveIcon from '@/assets/sidenav-icons/NNU-Active.svg';
import nnuIdleIcon from '@/assets/sidenav-icons/NNU-Idle.svg';
import quickTasksActiveIcon from '@/assets/sidenav-icons/QuickTasks-Active.svg';
import quickTasksIdleIcon from '@/assets/sidenav-icons/QuickTasks-Idle.svg';
import reportingActiveIcon from '@/assets/sidenav-icons/Reporting-Active.svg';
import reportingIdleIcon from '@/assets/sidenav-icons/Reporting-Idle.svg';
import salesActiveIcon from '@/assets/sidenav-icons/Sales-Active.svg';
import salesIdleIcon from '@/assets/sidenav-icons/Sales-Idle.svg';

type IconProps = {
  src: any;
  alt: string;
  width?: number;
  height?: number;
};

function ImageIcon({ src, alt, width = 24, height = 24 }: IconProps) {
  return (
    <Image
      className="svg-icon"
      src={src}
      alt={alt}
      width={width}
      height={height}
    />
  );
}

export function JobsIcon({ active = false }: { active?: boolean }) {
  return active ? (
    <ImageIcon src={jobsActiveIcon} alt="jobs active icon" width={29} />
  ) : (
    <ImageIcon src={jobsIdleIcon} alt="jobs idle icon" width={29} />
  );
}

export function TasksIcon({ active = false }: { active?: boolean }) {
  return active ? (
    <ImageIcon src={tasksActiveIcon} alt="tasks active icon" />
  ) : (
    <ImageIcon src={tasksIdleIcon} alt="tasks idle icon" />
  );
}

export function MeIcon({ active = false }: { active?: boolean }) {
  return active ? (
    <ImageIcon src={meActiveIcon} alt="me active icon" width={20} />
  ) : (
    <ImageIcon src={meIdleIcon} alt="me idle icon" width={20} />
  );
}

export function ChatIcon({ active = false }: { active?: boolean }) {
  return active ? (
    <ImageIcon src={chatActiveIcon} alt="chat active icon" />
  ) : (
    <ImageIcon src={chatIdleIcon} alt="chat idle icon" />
  );
}

export function ContactsIcon({ active = false }: { active?: boolean }) {
  return active ? (
    <ImageIcon
      src={contactsActiveIcon}
      alt="contacts active icon"
      width={25}
      height={10}
    />
  ) : (
    <ImageIcon
      src={contactsIdleIcon}
      alt="contacts idle icon"
      width={12}
      height={10}
    />
  );
}

export function NNUIcon({ active = false }: { active?: boolean }) {
  return active ? (
    <ImageIcon src={nnuActiveIcon} alt="nnu active icon" />
  ) : (
    <ImageIcon src={nnuIdleIcon} alt="nnu idle icon" />
  );
}

export function QuickTasksIcon({ active = false }: { active?: boolean }) {
  return active ? (
    <ImageIcon src={quickTasksActiveIcon} alt="quicktasks active icon" />
  ) : (
    <ImageIcon src={quickTasksIdleIcon} alt="quicktasks idle icon" />
  );
}

export function ReportingIcon({ active = false }: { active?: boolean }) {
  return active ? (
    <ImageIcon src={reportingActiveIcon} alt="reporting active icon" />
  ) : (
    <ImageIcon src={reportingIdleIcon} alt="reporting idle icon" />
  );
}

export function SalesIcon({ active = false }: { active?: boolean }) {
  return active ? (
    <ImageIcon src={salesActiveIcon} alt="sales active icon" />
  ) : (
    <ImageIcon src={salesIdleIcon} alt="sales idle icon" />
  );
}

export function SettingsIcon({ active = false }: { active?: boolean }) {
  return active ? (
    <CiSettings
      size={26}
      style={{
        color: !active ? '#8EE000' : 'var(--nn-color-primary)',
        filter: !active ? 'none' : 'var(--nn-filter-invert)',
      }}
    />
  ) : (
    <CiSettings size={26} style={{ color: 'var(--nn-color-text)' }} />
  );
}
